module.exports = __webpack_public_path__ + "img/37C337_279F27_186018_248824-256px.f60de504.png";